import { openConfirmationModal } from '../../../shared/components/modal/openConfirmationModal';
import { useModalStore } from '../../../shared/store/uiStore';
import CategoryForm from './CategoryForm';
import { deleteCategory } from '../categories.action';
import { useCategoriesStore } from '../categories.store';

export const openCategoryModal = async (
  categoryId: string = '',
  query: string = '',
  type: 'create' | 'update'
) => {
  if (type === 'create') {
    useModalStore.getState().openModal({
      id: 'category-form-create-modal',
      title: 'Create Category',
      size: 'sm',
      content: <CategoryForm query={query} id={categoryId} />,
      buttons: [
        {
          label: 'Create',
          form: 'category-form',
          type: 'submit',
          variant: 'primary',
        },
        {
          label: 'Cancel',
          onClick: () => {
            useModalStore.getState().closeModal();
          },
          type: 'button',
          variant: 'outline',
        },
      ],
    });
    return;
  }

  const categories = useCategoriesStore.getState().items;

  const categoryName = categories[categoryId].name || 'n/a';

  useModalStore.getState().openModal({
    id: 'category-form-edit-modal',
    title: 'Edit DrillDown Category',
    size: 'sm',
    content: <CategoryForm id={categoryId} />,
    buttons: [
      {
        label: 'Save',
        form: 'category-form',
        type: 'submit',
        variant: 'primary',
      },
      {
        label: 'Cancel',
        onClick: () => {
          useModalStore.getState().closeModal();
        },
        type: 'button',
        variant: 'outline',
      },
      {
        label: 'Delete',
        onClick: () => {
          openConfirmationModal({
            message: `Are you sure you want to delete the category: ${categoryName}?`,
            onConfirm: () => deleteCategory(categoryId),
            variant: 'danger',
          });
        },
        type: 'button',
        variant: 'danger',
      },
    ],
  });
};
